// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"f10c45d9","391":"f02aae8f"}[chunkId] + ".chunk.css";
};